import React from 'react';
import { useGetOpenTasksByFamilyQuery } from '../api/taskApi';

interface OpenTasksListProps {
  familyId: string;
}

const OpenTasksList: React.FC<OpenTasksListProps> = ({ familyId }) => {
  const { data: tasks, isLoading, isError } = useGetOpenTasksByFamilyQuery(
    { familyId },
    { skip: !familyId }
  );

  if (!familyId) {
    return null; // לא מציג כלום אם אין familyId
  }

  if (isLoading) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-yellow-800 mb-2">
          📋 משימות פתוחות
        </h3>
        <p className="text-yellow-600">טוען משימות...</p>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-red-800 mb-2">
          📋 משימות פתוחות
        </h3>
        <p className="text-red-600">שגיאה בטעינת המשימות</p>
      </div>
    );
  }

  // המשימות כבר מסוננות ב-backend (רק פתוחות)
  const openTasks = tasks || [];

  if (openTasks.length === 0) {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <h3 className="text-lg font-semibold text-green-800 mb-2">
          📋 משימות פתוחות
        </h3>
        <p className="text-green-600">✅ אין משימות פתוחות - כל הכבוד!</p>
      </div>
    );
  }

  return (
    <div className="bg-orange-50 border border-orange-200 rounded-lg p-4">
      <h3 className="text-lg font-semibold text-orange-800 mb-3">
        📋 משימות פתוחות ({openTasks.length})
      </h3>
      <div className="space-y-2">
        {openTasks.map((task) => (
          <div
            key={task.id}
            className="bg-white border border-orange-200 rounded-md p-3 shadow-sm"
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <h4 className="font-medium text-gray-900 text-right">
                  {task.name}
                </h4>
                {task.details && (
                  <p className="text-sm text-gray-600 mt-1 text-right">
                    {task.details}
                  </p>
                )}
              </div>
              <div className="mr-3 flex-shrink-0">
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  בתהליך
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-3 text-xs text-orange-600 text-right">
        💡 משימות אלו מפגישות קודמות וממתינות להשלמה
      </div>
    </div>
  );
};

export default OpenTasksList;